declare namespace $ {

	type $mol_view__sub_shm_hitalama_components_preview_description_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_components_preview_description_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_preview_description_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview_description['edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_preview_description_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_components_preview_description_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_components_preview_description_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview_description['text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_preview_description_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_preview_description_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview_description['cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_textarea__hint_shm_hitalama_components_preview_description_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_hitalama_components_preview_description_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview_description['draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_button_major__title_shm_hitalama_components_preview_description_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_components_preview_description_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview_description['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	export class $shm_hitalama_components_preview_description extends $mol_view {
		Label( ): $mol_view
		edit( next?: any ): any
		Edit_icon( ): $mol_icon_pencil
		Edit( ): $mol_button_minor
		actions( ): readonly($mol_view)[]
		Header( ): $mol_view
		text( ): string
		Text( ): $shm_hitalama_text
		content( ): readonly($mol_view)[]
		cancel( next?: any ): any
		draft( next?: string ): string
		save( next?: any ): any
		definition( ): $shm_hitalama_map_widget_entity_custom
		sub( ): readonly(any)[]
		Cancel( ): $mol_button_minor
		Textarea( ): $mol_textarea
		Save( ): $mol_button_major
	}
	
}

//# sourceMappingURL=description.view.tree.d.ts.map